module.exports = __webpack_public_path__ + "static/media/Sponsor Logos.093141b6.ai";